import styles from './CreateButtonCircle.module.css';

interface ICreateButtonCircle {
  openCreateButtonConfirmationModalCallbackHandler: (flag: boolean) => void;
}

const CreateButtonCircle = ({
  openCreateButtonConfirmationModalCallbackHandler
}: ICreateButtonCircle) => {
  const openModalHandler = () => {
    openCreateButtonConfirmationModalCallbackHandler(true);
  };
  return (
    <div className={styles.circleContainer} data-testid={'circleDivTestId'}>
      <button onClick={openModalHandler} type={'button'} className={styles.circle}>
        <span className={styles.circleText}>Create Incident</span>
      </button>
    </div>
  );
};

export default CreateButtonCircle;
